import React, { useState } from "react";
import { transportType } from "common/data";
import TransportInfo from "components/TransportInfo";
import BuildARoute from "components/BuildARoute";
import styles from "./styles.module.scss";
import data from "common/data";

const SecondScreen = () => {
  const [toValue, setToValue] = useState();
  const [fromValue, setFromValue] = useState();

  const returnValues = (toValue, fromValue) => {
    setToValue(toValue);
    setFromValue(fromValue);
  };

  return (
    <div className={styles["second-screen"]}>
      <h3>Маршрут</h3>
      <BuildARoute returnValues={returnValues} />
      {/* <div className={styles.saved}>
      <Button kind="secondary" size="s">
        Дом
      </Button>
      <Button kind="secondary" size="s">
        Работа
      </Button>
    </div> */}
      <div className={styles.popular}>
        <p className={styles["text-accent"]}>Чаще всего ищут:</p>
        <div className={styles["transport-types"]}>
          {Object.values(transportType).map((transport) => {
            return (
              <div className={styles.transport} key={transport.type}>
                {transport.type}
                <img
                  className={styles.transport_img}
                  alt={transport.type}
                  src={require(`./images/${transport.img}`)}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.routes}>
        <p className={styles["text-accent"]}>На чем добраться?</p>
      </div>

      {data.bus.properties.vspu.map((bus) => {
        if (bus.startFrom?.toLowerCase().includes(fromValue?.toLowerCase())) {
          return (
            <div className={styles["state-manually"]} key={bus.name}>
              <TransportInfo number={bus.name} route={bus.startFrom} />
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default SecondScreen;
